// CC/Bcc addresses are persisted as a JSON string array on both the per-message
// snapshot (Message.CcAddressesJSON) and the template defaults
// (TemplateVersion.DefaultCcAddresses). One wire format, one pair of helpers,
// shared by the message viewer and the template editor.

/** Parse a stored JSON array of addresses. Null/empty/malformed → []. */
export function parseAddresses(json?: string | null): string[] {
	if (!json) return [];
	try {
		const arr = JSON.parse(json);
		return Array.isArray(arr) ? arr.filter((a): a is string => typeof a === 'string') : [];
	} catch {
		return [];
	}
}

/** Serialize addresses to the stored JSON array, or undefined for an empty list. */
export function serializeAddresses(addrs: string[]): string | undefined {
	return addrs.length ? JSON.stringify(addrs) : undefined;
}
